import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

export const firebaseConfig = {
  apiKey: "AIzaSyAxNRxFRipNb88CkncAd0YZcTObilv1NQ0",
  authDomain: "checklist-eb706.firebaseapp.com",
  projectId: "checklist-eb706",
  storageBucket: "checklist-eb706.firebasestorage.app",
  messagingSenderId: "581184675737",
  appId: "1:581184675737:web:f11158b067aa2bcc403d08",
  measurementId: "G-GNDFLM8943"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
